import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

const HEADING_HEIGHT_AND_MARGIN = 32;
const PARAGRAPH_LINE_HEIGHT = 14;
const PARAGRAPH_LINE_SPACING = 6;

export const License: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="90px">
    {/* Title */}
    <rect x="0" y="0" rx="3" ry="3" width="150px" height="24" />
    {/* Description */}
    <rect x="0" y={HEADING_HEIGHT_AND_MARGIN} rx="3" ry="3" width="100%" height={PARAGRAPH_LINE_HEIGHT} />
    <rect x="0" y={HEADING_HEIGHT_AND_MARGIN + (PARAGRAPH_LINE_HEIGHT + PARAGRAPH_LINE_SPACING) * 1} rx="3" ry="3" width="100%" height={PARAGRAPH_LINE_HEIGHT} />
    <rect x="0" y={HEADING_HEIGHT_AND_MARGIN + (PARAGRAPH_LINE_HEIGHT + PARAGRAPH_LINE_SPACING) * 2} rx="3" ry="3" width="62%" height={PARAGRAPH_LINE_HEIGHT} />
  </ContentLoader>
);

export const Origin: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="27px">
    {/* Badge */}
    <rect x="0" y="1" rx="3" ry="3" width="80px" height="21px" />
    {/* Text */}
    <rect x="88px" y="4" rx="2" ry="2" width="225px" height="15px" />
  </ContentLoader>
);
